// Generated by https?://quicktype.io

export interface Transfer {
    id?: string;
    currency?: string;
    trading_account?: string;
    amount?: number;
    order_number?: null;
    to_currency?: string;
    to_trading_account?: string;
    to_order_number?: null;
    to_amount?: number;
    conversion_rate?: number;
    conversion_date?: string;
    ip_address?: string;
    created_date?: string;
    updated_date?: string;
    users_linked?: [{
        id?: string;
        email?: string;
    }];
}
